import React from 'react';
import { Link } from 'react-router-dom';
import TableWrapper from '../../elements/TableWrapper';
import {
    Layout,
    message,
    Button,
    Modal
} from 'antd';
import MiCompAPI from '../../../util/api';
import Invitemember from './Invitemember';
import SearchMemberForm from './SearchMemberForm';


const { Content } = Layout;
class Producermember extends React.Component {
    constructor(props) {
        super(props);
        this.columns = [{
            title: 'Name',
            dataIndex: 'name',
            render: (text, record) => {return <Link to={{ pathname: '/providersearch', state: record['user_ID'] }}>{text}</Link>},

        },
        {
            title: 'Policy Id',
            dataIndex: 'policyId',
        }, {
            title: 'Email',
            dataIndex: 'email',
        },
        {
            title: 'Registered',
            dataIndex: 'isRegistered',
            render: (text) => text ? "Yes" : "No"
        },

        {
            title: 'Actions',
            render: (text, record) => <>
                {record.isInvited && !record.isRegistered ? <Button onClick={() => {
                    if (record.email&&record.email!=='') {

                        this.inviteActiveSubmitHandler({email:record.email,id:record.mem_ID});
                    } else {
                        this.inviteActiveDefaultHandler(record);
                    }
                }} className="ant-btn submit-button ant-btn-primary">Re-Invite</Button> : record.isRegistered && record.isInvited ? <></> : !record.isRegistered && !record.isInvited ? <Button onClick={() => this.inviteActiveDefaultHandler(record)} className="ant-btn submit-button ant-btn-primary">Invite</Button> : <Button onClick={() => this.inviteActiveDefaultHandler(record)} className="ant-btn submit-button ant-btn-primary">ReInvite</Button>}
            </>
        }];

        this.state = {
            allMembersLoading: true,
            inviteActive: false,
            id: undefined,
            data: []


        }
        this.api = new MiCompAPI(this.props.userPermandMasters);
    }
    inviteActiveDefaultHandler = (record) => {
        this.setState({ inviteActive: !this.state.inviteActive, id: record.mem_ID });
    };
    inviteActiveSubmitHandler = (data, callback) => {
        this.setState({
            allMembersLoading: true
          });
        this.api.invoke("InviteMember/" + data.email + "/" + data.id, "post", (data, success) => {
            if (success) {
                if (data.statusCode === 200) {
                    message.destroy();
                    message.success(data.statusMessage, 3);
                    this.inviteActiveDefaultHandler({ id: undefined })

                }
                else {
                    message.destroy();
                    message.error(data.statusMessage, 3);
                }
                this.getMembers();
            }
            this.setState({
                allMembersLoading: false
              });
        });
    }
    componentDidMount() {
        this.getMembers();
    }

    GetMembersWithSearchOptions = (plan) => {

        this.api.invoke(
            "GetMembersWithSearchOptions/" + plan,
            "get",
            (data, success) => {

                if (success) {
                    if (data.statusCode === 200) {
                        const members = data.data;
                        this.setState({
                            data: members,
                            allMembersLoading: false
                        });
                    } else {
                        message.destroy();
                        message.error(data.statusMessage, 3);
                    }
                }
            },
        );
    };
    getMembers() {
        this.api.invoke("GetMembers", "get", (data, success) => {
            if (success) {
                if (data.statusCode === 200) {
                    const members = data.data;
                    this.setState({
                        data: members,
                        allMembersLoading: false
                    });
                } else {
                    message.destroy();
                    message.error(data.statusMessage, 3);
                }
            }
        });
    }
    render() {
        return (
            <Content>
                {this.state.inviteActive && this.state.id ?
                    <Modal
                        visible={this.state.inviteActive}
                    >
                        <Invitemember id={this.state.id}
                            closeDrawerHandler={this.inviteActiveDefaultHandler}
                            submitHandler={this.inviteActiveSubmitHandler}
                            width={500}
                            title="Invite"
                        />
                    </Modal> : ""}
                <div className="mi_main_div" style={{paddingTop:"1px"}}>                    
                    <SearchMemberForm userPermandMasters={this.props.userPermandMasters} submitHandler={this.GetMembersWithSearchOptions}></SearchMemberForm>                    
                    <div style={{padding:"10px"}}>
                    <TableWrapper rowKey="id" columns={this.columns} data={this.state.data} loading={this.state.allMembersLoading} title="All Members" search={true} />
                    </div>
                </div>
            </Content>
        );
    }
}
export default Producermember;